{
	"accounts": "Accounts",
	"invitations": "Invitations",
	"subscribeToFeedback": "Subscribe to feedback program",
	"notificationSettings": {
		"title": "Email notifications settings",
		"invoicingInformation": "Invoicing information",
		"declarationProcessingStatus": "Declaration processing status",
		"enabled": "On",
		"disabled": "Off",
		"toast": {
			"success": "Notification preference updated",
			"error": "Failed to update notification preference"
		}
	},
	"about": {
		"title": "About",
		"termsAndConditions": "Terms and Conditions",
		"privacyPolicy": "Privacy Policy",
		"imprint": "Imprint",
		"openSourceAttribution": "Open Source Attribution"
	},
	"language": {
		"title": "Language",
		"footer": "Language changes will propagate to all Heidelberg Materials applications"
	},
	"impressum": "Imprint",
	"copyright": "© 2024 Heidelberg Materials. All rights reserved.",
	"login": "Login",
	"logout": "Logout"
}
